// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"307":"38d9335f","353":"df6c7474","461":"e8cc7679","672":"de09c5dc","705":"2e04a99b","814":"92fbb735"}[chunkId] + ".js";
};